import { Reducer } from 'redux';
import { IResultState, ResultActions, ResultActionEnum } from '.';
import { IItaAuctionResult } from '../../services';

export const initialResultState: IResultState = {
  showResultPanel: false,
  itaAuctionResult: {} as IItaAuctionResult
};

export const resultReducer: Reducer<IResultState, ResultActions> = (
  state = initialResultState,
  action: ResultActions
) => {
  switch (action.type) {
    case ResultActionEnum.ShowResultPanel:
      return {
        ...state,
        showResultPanel: action.state?.showResultPanel,
        itaAuctionResult: action.state?.itaAuctionResult
      };
    case ResultActionEnum.HideResultPanel:
      return {
        ...state,
        showResultPanel: false,
      };    
    default:
      return state;
  }
};
